import { AutoComplete } from "antd";

interface CategoryInputProps {
  value: string;
  onChange: (value: string) => void;
  // Categorías ya usadas por la marca: se proponen al escribir.
  categories: string[];
  placeholder?: string;
  disabled?: boolean;
}

// Caja de texto con predictivo de las categorías ("submarcas" de Alerta) de una
// marca. Permite escribir una categoría nueva.
const CategoryInput: React.FC<CategoryInputProps> = ({
  value,
  onChange,
  categories,
  placeholder,
  disabled,
}) => {
  const needle = value.trim().toLowerCase();
  const options = categories
    .filter(
      (category) =>
        category.toLowerCase().includes(needle) &&
        category.toLowerCase() !== needle
    )
    .map((category) => ({ value: category }));

  return (
    <AutoComplete
      className="category-input"
      classNames={{ popup: { root: "edit-selection-overlay" } }}
      value={value}
      options={options}
      onChange={(next) => onChange(next ?? "")}
      placeholder={placeholder}
      disabled={disabled}
      allowClear
    />
  );
};

export default CategoryInput;
